import React, { useEffect } from 'react';

import { defaultFilterDebounceTime } from 'config/SearchForm/defaults';

import { useSync } from 'hooks/form/useSync';
import { useDebounce } from 'hooks/Wait/useDebounce';

import { filterAtom } from 'data/Atom/Filter';
import { filterStore } from 'data/Atom/Store';

interface DebounceFilterProviderProps {
    children?: React.ReactNode;
}

const DebounceFilterProvider = ({ children }: DebounceFilterProviderProps) => {
    const debounce = useDebounce();
    const { syncSearchWithFormAndFilterStore } = useSync();

    useEffect(() => {
        filterStore.sub(filterAtom, () => {
            debounce(() => {
                // sync the global searchStore with filter from filterStore
                syncSearchWithFormAndFilterStore();
            }, defaultFilterDebounceTime);
        });
    }, [debounce, syncSearchWithFormAndFilterStore]);

    return <>{children}</>;
};

export default DebounceFilterProvider;
